module.exports = __webpack_public_path__ + "img/avatarNotFound.6f8546c9.svg";